import * as React from "react";
import {Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";
import {IEngagementTabResponse} from "../../../../api/AdminAnalyticsApi";
import {
    axisTickStyle,
    chartColors,
    gridProps,
    gridStroke,
    SESSION_DEPTH_DESCRIPTION,
    tooltipStyle,
} from "../shared/analytics.constants";
import {numberWithCommas} from "../../../../utils/numberUtil";

interface ISessionDepthChartProps {
    sessionDepth: IEngagementTabResponse["sessionDepth"];
    avgSessionDepth: number;
}

export const SessionDepthChart: React.FC<ISessionDepthChartProps> = (props) => {
    const totalDailyVisits = props.sessionDepth.reduce((sum, r) => sum + r.sessionCount, 0);

    return (
        <section className="admin-analytics__section" data-testid={"session-depth"}>
            <div className="admin-analytics__section-header">
                <h2 className="admin-analytics__section-title">Daily Visit Depth</h2>
                <span className="admin-analytics__section-subtitle">
                    How many pages do users visit per day? (excludes /home and /client-reporting)
                </span>
            </div>
            <p className="admin-analytics__section-desc">{SESSION_DEPTH_DESCRIPTION}</p>
            <div className="admin-analytics__summary-grid">
                <div className="admin-analytics__summary-card admin-analytics__summary-card--total">
                    <div className="admin-analytics__summary-label">Avg Pages per Daily Visit</div>
                    <div className="admin-analytics__summary-value">{props.avgSessionDepth}</div>
                    <div className="admin-analytics__summary-note">distinct areas per user per day</div>
                </div>
                <div className="admin-analytics__summary-card admin-analytics__summary-card--internal">
                    <div className="admin-analytics__summary-label">Total Daily Visits</div>
                    <div className="admin-analytics__summary-value">{numberWithCommas(totalDailyVisits)}</div>
                    <div className="admin-analytics__summary-note">one user on one day = one daily
                        visit
                    </div>
                </div>
            </div>
            <div className="admin-analytics__chart">
                <ResponsiveContainer width="100%" height={300}>
                    <BarChart data={props.sessionDepth} margin={{bottom: 40}}>
                        <CartesianGrid {...gridProps} />
                        <XAxis dataKey="bucket" angle={-45} textAnchor="end" interval={0} height={60}
                               tick={{fontSize: 12, fill: chartColors.gray02}} axisLine={{stroke: gridStroke}}
                               tickLine={false}/>
                        <YAxis tick={axisTickStyle} axisLine={false} tickLine={false}/>
                        <Tooltip
                            formatter={(value, name) =>
                                [value as number, name === "sessionCount" ? "Daily Visits" : name]}
                            {...tooltipStyle} />
                        <Bar dataKey="sessionCount" fill={chartColors.tealDark} name="Daily Visits"/>
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </section>
    );
};
